import React, { FunctionComponent } from "react";
import { MenuItem, MenuItems } from "../../../../components/@types";
import YaraSelectInput from "./YaraSelectInput";

interface IYaraStringMatchRuleFilterProps {
  items?: MenuItems;
  active?: MenuItem;
  disabled?: boolean;
  onChange: (value: MenuItem) => void;
}

const YaraStringMatchRuleFilter: FunctionComponent<
  IYaraStringMatchRuleFilterProps
> = ({ items, active, disabled, onChange }) => (
  <YaraSelectInput
    label={"Rule"}
    placeholder={"Select Yara Rule"}
    allLabel={"All Rules"}
    items={items}
    active={active}
    disabled={disabled}
    onChange={onChange}
  />
);

export default YaraStringMatchRuleFilter;
